import React from 'react';
import utilFunction from '../../containers/function';
import AlertCurveChart from '../common/graphs/crossfilterGraphs/alertCurveChart';

const DriverAlertCurveGraph = props => {
  return (
    <div id="driver-alert-curve-graph" className="dc-chart-parent">
      {props.microSleep && (
        <section className="help-component circular-driver">
          <section className="box-help">
            <i className="fas fa-question-circle" />
            <section className="box">
              {props.language.driver_fatigue.help.events}
            </section>
          </section>
        </section>
      )}
      <AlertCurveChart
        id={'driver-alert-curve-graph-component'}
        language={props.language}
        additionalCrossfilterData={null}
        crossfilerData={utilFunction.generateCrossfilter(props.data)}
        stack={false}
        dimension={{
          formatFunction: [],
          name: 'date',
          originalName: 'date',
          reduceFunction: { type: 'CONTINUOUS_GROUP', typeof: 'DATE_TIME' }
        }}
        metrics={[]}
        config={{
          tooltip: {
            valuesConfig: [
              {
                identifier: 'type',
                valueFormat: { type: 'STRING', format: '' },
                wrapper: `<div class="display_%v" style='text-align:left;'><span style='font-weight:bold;'>${
                  props.tooltip.alertLevel
                }:</span> %v</div>`
              },
              {
                identifier: 'event',
                valueFormat: { type: 'STRING', format: '' },
                wrapper: `<div class="display_%v" style='text-align:left;'><span style='font-weight:bold;'>${
                  props.tooltip.event
                }:</span> %v</div>`
              },
              {
                identifier: 'length',
                valueFormat: { type: 'NUMBER', format: 'hh:mm' },
                wrapper: `<div class="display_%v" style='text-align:left;'><span style='font-weight:bold;'>${
                  props.tooltip.duration
                }:</span> %v</div>`
              },
              {
                identifier: 'startDate',
                valueFormat: { type: 'DATE_TIME_UTC', format: '%I:%M %p' },
                wrapper: `<div class="display_%v" style='text-align:left;'><span style='font-weight:bold;'>${
                  props.tooltip.start
                }:</span> %v</div>`
              },
              {
                identifier: 'hour',
                valueFormat: { type: 'DATE_TIME_UTC', format: '%I:%M %p' },
                wrapper: `<div class="display_%v" style='text-align:left;'><span style='font-weight:bold;'>${
                  props.tooltip.hour
                }:</span> %v</div>`
              },
              {
                identifier: 'endDate',
                valueFormat: { type: 'DATE_TIME_UTC', format: '%I:%M %p' },
                wrapper: `<div class="display_%v" style='text-align:left;'><span style='font-weight:bold;'>${
                  props.tooltip.end
                }:</span> %v</div>`
              },
              {
                identifier: 'place',
                valueFormat: { type: 'STRING', format: '' },
                wrapper: `<div class="display_%v" style='text-align:left;'><span style='font-weight:bold;'>${
                  props.tooltip.place
                }:</span> %v</div>`
              },
              {
                identifier: 'sleepTooltip',
                valueFormat: { type: 'STRING', format: '' },
                wrapper: `<div class="display_%v" style='text-align:left;'><span style='font-weight:bold;'>
                </span>%v</div>`
              }

            ]
          },
          eventsCol: {
            type: 'activity',
            start: 'startHour',
            length: 'duration',
            lane: 'date',
            zIndex: 'priority',
            isStart: 'startFlag',
            isEnd: 'endFlag',
            place: 'site',
            sleepTooltip: 'sleepTooltip'
          },
          eventsLabels: [
            { type: 'ASleep', label: `${props.graphLabels.aSleep}`, level: 0 },
            { type: 'A1', label: `${props.graphLabels.a1}`, level: 1 },
            { type: 'A2', label: `${props.graphLabels.a2}`, level: 1 },
            { type: 'A3', label: `${props.graphLabels.a3}`, level: 1 },
            { type: 'A4', label: `${props.graphLabels.a4}`, level: 1 },
            { type: 'A5', label: `${props.graphLabels.a5}`, level: 1 },
            { type: 'A6', label: `${props.graphLabels.a6}`, level: 1 },
            { type: 'A7', label: `${props.graphLabels.a7}`, level: 1 },
            { type: 'roadWarning', label: `${props.graphLabels.roadWarning}`, level: 2 },
          ],
          valueFormat: { type: 'DATE_TIME', format: props.language.account.date.graphFormatXAxis },
          colors: [
            '#f5f9ff', '#7ABA7E', '#B4D288' ,'#CFDC8C', '#F9E58E', '#F3C184','#EE9577', '#E57D70', '#ccc'
          ],
          eventsToHide: ['ASleep'],
          levelsNames: { '1': 'Estado' },
          hoursCol: { show: false},
          showLevel2Legend: true,
          hideSeparators: true,
          lineHeight: 28,
          extraIndicatorCol: {
            show: props.microSleep ? true : false,
            type: 'roadWarningCount',
            title: props.language.driver_fatigue.graphAlertStateLabels.events.toUpperCase(),
            valueFormat: { type: 'NUMBER', format: '.0f' },
            fontSize: '16px',
            colorRange: [
              {
                color: '#41C99F',
                range: [{ value: props.graphColorRange.outOfRisk[1], operator: '<' }]
              },
              {
                color: '#CC5660',
                range: [{ value: props.graphColorRange.higherRisk[0], operator: '>=' }]
              }
            ]
          },
          extraIndicatorCol2: {
            show: true,
            type: 'DailySummary',
            title: props.language.driver_fatigue.graphAlertStateLabels.analysis,
            valueFormat: { type: 'NUMBER', format: '.0f' },
            fontSize: '16px',
            colorRange: [
              { color: '#41C99F', range: [{ value: 1, operator: '<' }] },
              {
                color: '#F3B119',
                range: [{ value: 1, operator: '>=' }, { value: 2, operator: '<' }]
              },
              { color: '#CC5660', range: [{ value: 2, operator: '>=' }] }
            ]
          }
        }}
        dashboardId={'driver_fatigue'}
      />
    </div>
  );
};
export default DriverAlertCurveGraph;



// WEBPACK FOOTER //
// ./source/client/components/driver_roadwarning/driverAlertCurveGraph.jsx